__webpack_require__.ts = (script) => (__webpack_require__.tt().createScript(script));